import {
  Table,
  TableHead,
  TableContainer,
  Paper,
  TableCell,
  TableRow,
  TableBody,
  Button,
  TablePagination,
} from '@mui/material';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';
import React, { useState } from 'react';
import { formatEmployeeThaiName } from '../../utils/functions/employeeName';
import _ from 'lodash';

import { useHistory } from 'react-router';

export default function CheckInlist({
  timestamp,
  page: pageProp,
  size: sizeProp,
  setPage: setPageProp,
  setSize: setSizeProp,
  disabledButton,
  uiLang = 'en',
}) {
  const U = (th, en) => (uiLang === 'en' ? en : th);
  const [internalPage, setInternalPage] = useState(1);
  const [internalSize, setInternalSize] = useState(12);

  const page = typeof setPageProp === 'function' ? (pageProp || 1) : internalPage;
  const size = typeof setSizeProp === 'function' ? (sizeProp || 12) : internalSize;
  const setPage = typeof setPageProp === 'function' ? setPageProp : setInternalPage;
  const setSize = typeof setSizeProp === 'function' ? setSizeProp : setInternalSize;

  const history = useHistory();
  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value);
    setPage(1);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };
  // เดิม map ทั้ง timestamp.rows ตรงๆ ไม่มีการตัดหน้าเลย ทำให้ TablePagination ควบคุม
  // อะไรไม่ได้จริง (rows แสดงครบทุกแถวเสมอไม่ว่า page/size จะเป็นเท่าไหร่) — ตัดหน้าฝั่ง client เอง
  const pagedRows = (timestamp?.rows || []).slice((page - 1) * size, (page - 1) * size + size);
  // const late = _?.filter(checkIn?.arr, (e) => e?.late_status === true);
  // const normal = _?.filter(checkIn?.arr, (e) => e?.late_status === false);

  return (
    <div>
      <Paper>
        <TableContainer component={Paper}>
          <Table aria-label="simple table" size="small">
            <colgroup>
              <col width="30%" />
              <col width="30%" />
              <col width="20%" />
            </colgroup>
            <TableHead>
              <TableRow className={'bg-gray-600 text-white'}>
                <TableCell>
                  <h1 className="font-bold  text-center  text-white ">
                    {' '}
                    {U('พนักงาน', 'Employee')}
                  </h1>
                </TableCell>
                <TableCell>
                  <h1 className="font-bold  text-center text-white "> {U('วันที่', 'Date')}</h1>
                </TableCell>
                <TableCell>
                  <h1 className="font-bold text-center text-white ">
                    {U('เวลาเข้า', 'Check in')}
                  </h1>
                </TableCell>
                <TableCell>
                  <h1 className="font-bold text-center text-white ">
                    {U('เวลาออก', 'Check out')}
                  </h1>
                </TableCell>
                <TableCell>
                  <h1 className="font-bold text-center text-white ">{U('จำนวน', 'Count')}</h1>
                </TableCell>
                <TableCell>
                  <h1 className="font-bold text-center text-white "></h1>
                </TableCell>

                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            {timestamp?.rows?.length !== 0 ? (
              <TableBody>
                {pagedRows.map((e) => (
                  <TableRow key={e?._id}>
                    <TableCell>
                      <h1 className=" text-center ">
                        {formatEmployeeThaiName(e?.employee)}
                      </h1>
                    </TableCell>
                    <TableCell>
                      <h1 className=" text-center ">
                        {dayjs(e?.checkIn).format('DD/MM/YYYY')}
                      </h1>
                    </TableCell>
                    <TableCell>
                      <h1 className="text-center ">
                        {dayjs(e?.checkIn).format('HH:mm')}
                      </h1>
                    </TableCell>
                    <TableCell>
                      {e?.status_checkOut ? (
                        <div>
                          <h1 className="text-center ">
                            {dayjs(e?.checkOut).format('HH:mm') ||
                              'ยังไม่เช็คชื่อ'}
                          </h1>
                        </div>
                      ) : (
                        <h1 className="text-theme-600">waiting</h1>
                      )}
                    </TableCell>
                    <TableCell>
                      <h1 className="text-center ">{e?.amount || 0}</h1>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={3}>
                    {U('ไม่มีรายการ', 'No items')}
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 12, 20, 30, 100]}
          component="div"
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          count={timestamp?.rows?.length || 0}
          rowsPerPage={size}
          page={page - 1}
        />
      </Paper>
    </div>
  );
}
CheckInlist.propTypes = {
  checkIn: PropTypes.object,

  page: PropTypes.object,
  size: PropTypes.object,

  setPage: PropTypes.object,
  setSize: PropTypes.object,
  disabledButton: PropTypes.bool,
};
CheckInlist.defaultProps = {
  page: null,
  size: null,
  setPage: null,
  setSize: null,
  disabledButton: false,
};
